import { DateFormats, NULL_UUID } from '@uplift/constants';
import { CalendarDateService } from '@uplift/services';
import { Modality, ModalityEnum } from '@uplift/types';

import { BookingForEnum } from './types';
import { PsychiatryOnlyUtmSource } from '@uplift/api';

export const getModalityFromBookingForEnum = (bookingFor: BookingForEnum) => {
  switch (bookingFor) {
    case BookingForEnum.MyselfAndPartner:
      return ModalityEnum.couples;
    case BookingForEnum.MyselfAndFamily:
      return ModalityEnum.families;
    default:
      return ModalityEnum.individual;
  }
};

export const getBookingForEnumFromModality = (modality: Modality): BookingForEnum => {
  switch (modality.modality) {
    case ModalityEnum.individual:
      return BookingForEnum.Myself;
    case ModalityEnum.couples:
      return BookingForEnum.MyselfAndPartner;
    case ModalityEnum.families:
      return BookingForEnum.MyselfAndFamily;
    default:
      return BookingForEnum.SomeoneElse;
  }
};

export const formBirthDateFormatToBackendFormat = (dateString: string | Date) => {
  const date = CalendarDateService.date(dateString, DateFormats.DEFAULT_DATE);
  const dateFormatted = date.format(DateFormats.ISO_DATE);

  return dateFormatted;
};


export const backendBirthDateFormatToFormFormat = (dateString: string) => {
  const date = CalendarDateService.date(dateString, DateFormats.ISO_DATE);
  const dateFormatted = date.format(DateFormats.DEFAULT_DATE);

  return dateFormatted;
};

const UTM_COOKIE_NAME = 'utmParams';
const getDomain = () => {
  if (window.location.hostname.includes('localhost')) {
    return 'localhost';
  }

  return 'joinuplift.co';
};


type UTMParams = Record<string, string> & {
  referrer?: string;
  utm_source?: string;
  utm_id?: string;
};


export const checkUTMParamsIsPsychiatryOnlyUser = (utmParams: UTMParams, psychiatryOnlyUtmSources: PsychiatryOnlyUtmSource[] = []) => {
  return psychiatryOnlyUtmSources.some(s => s.value === utmParams.utm_source);
};

export const checkUTMParamsIsPsychiatryOnlyPaidTraffic = (utmParams: UTMParams, psychiatryOnlyUtmSources: PsychiatryOnlyUtmSource[] = []) => {
  return psychiatryOnlyUtmSources.some(s => s.value === utmParams.utm_source && s.isPaidTraffic);
};


export const getAllUTMParams = () => {
  const utmParams: UTMParams = {};
  const urlParams = new URLSearchParams(window.location.search);

  if (document.referrer) {
    utmParams.referrer = document.referrer;
  }

  urlParams.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      utmParams[key] = value;
    }
  });

  return utmParams;
};


export const captureUTMParamsIntoCookie = () => {
  const utmParams = getAllUTMParams();

  if (Object.keys(utmParams).length > 0) {
    const expiryDate = new Date();

    /*
    set expiry date to 5 days from now
    */
    expiryDate.setDate(expiryDate.getDate() + 5);

    /*
    the dot in front of the domain makes the cookie available to domain and all subdomains
    */
    document.cookie = `${UTM_COOKIE_NAME}=${encodeURIComponent(JSON.stringify(utmParams))}; domain=.${getDomain()}; path=/; expires=${expiryDate.toUTCString()};`;
  }

  return utmParams;
};


export const getUtmParamsFromCookie = () => {
  // cookie is a string of key value pairs separated by '; '
  const cookie = document.cookie;
  const cookieArray = cookie.split('; ');
  const utmParamsCookie = cookieArray.find((c) => c.startsWith(`${UTM_COOKIE_NAME}=`));

  if (utmParamsCookie) {
    try {
      const utmParams: UTMParams = JSON.parse(decodeURIComponent(utmParamsCookie.split('=')[1]));

      return utmParams;
    } catch (error) {
      console.error('Error parsing utmParams cookie', error);
      return {};
    }
  }

  return {};
};

export const SELF_PAY_ID = NULL_UUID;
export const NO_STATE_ID = NULL_UUID;
export const OTHER_NON_PARTNER_INSURANCE_ID = '00000000-0000-0000-0000-000000000001';
